import PrimaryDetails from './container/index';

export default PrimaryDetails;



// WEBPACK FOOTER //
// ./src/components/page/PrimaryDetails/index.js